import { gql } from "@apollo/client";
import { Query } from "@apollo/client/react/components";
import { compose, graphql, ApolloProvider } from "@apollo/client/react/hoc";

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";

import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Neighbor
const GQLAddNeighborhood = gql`
  mutation createNeighborhood(
    $name: String
    $city: String
    $state: String
    $streetaddress: String
    $zip: String
    $npiCityRanking: String
    $npiAreaRanking: String
    $reviewSummary: String
    $reviewOneLiner: String
    $schoolScore: String
    $crimeRate: String
    $walkability: String
    $publicspaces: String
    $curbAppeal: String
    $price: Int
    $npi: String
    $valueIndex: String
    $keyword: String
    $similarneighborhoodIds: String
  ) {
    createNeighborhood(
      name: $name
      city: $city
      state: $state
      streetaddress: $streetaddress
      zip: $zip
      npiCityRanking: $npiCityRanking
      npiAreaRanking: $npiAreaRanking
      reviewSummary: $reviewSummary
      reviewOneLiner: $reviewOneLiner
      schoolScore: $schoolScore
      crimeRate: $crimeRate
      walkability: $walkability
      publicspaces: $publicspaces
      curbAppeal: $curbAppeal
      price: $price
      npi: $npi
      valueIndex: $valueIndex
      keyword: $keyword
      similarneighborhoodIds: $similarneighborhoodIds
    ) {
      success
      message
    }
  }
`;

const GQLAddSubscription = gql`
  mutation createsubscription(
    $email: String
    $subscribe_for: String
    $date: String
    $neighborhoodid: String
    $neighborhoodfullname: String
  ) {
    createsubscription(
      email: $email
      subscribe_for: $subscribe_for
      date: $date
      neighborhoodid: $neighborhoodid
      neighborhoodfullname: $neighborhoodfullname
    ) {
      success
      message
    }
  }
`;

//Update Neighbor
const Updateneighborhood = gql`
  mutation updateneighbor($id: String, $walkscorestatus: String) {
    updateNeighborhood(id: $id, walkscorestatus: $walkscorestatus) {
      success
      message
    }
  }
`;

//Update Neighbor
const Updateneighborhoodcrime = gql`
  mutation updateneighborcrime(
    $id: String
    $name: String
    $county_name: String
    $postalcity_name: String
    $crime: Float
  ) {
    updateNeighborhoodcrime(
      id: $id
      name: $name
      county_name: $county_name
      postalcity_name: $postalcity_name
      crime: $crime
    ) {
      success
      message
    }
  }
`;

//Update Neighbor Marketing Factor
const Updatemarketingfactor = gql`
  mutation updatemarketingfactor(
    $id: String
    $medianprice: Float
    $appreciation: Float
    $dom: Float
  ) {
    updatemarketingfactor(
      id: $id
      medianprice: $medianprice
      appreciation: $appreciation
      dom: $dom
    ) {
      success
      message
    }
  }
`;

const Updateneighborhoodmedianprice = gql`
  mutation updateneighbormedianprice(
    $id: String
    $name: String
    $county_name: String
    $postalcity_name: String
    $medianprice: Float
  ) {
    updateNeighborhoodmedianprice(
      id: $id
      name: $name
      county_name: $county_name
      postalcity_name: $postalcity_name
      medianprice: $medianprice
    ) {
      success
      message
    }
  }
`;

//Update Neighbor school
const Updateneighborhoodschool = gql`
  mutation updateneighborschool(
    $name: String
    $county_name: String
    $postalcity_name: String
    $school: Float
    $primaryschoolscore: Float
    $middleschoolscore: Float
    $highschoolscore: Float
  ) {
    updateNeighborhoodschool(
      name: $name
      county_name: $county_name
      postalcity_name: $postalcity_name
      school: $school
      primaryschoolscore: $primaryschoolscore
      middleschoolscore: $middleschoolscore
      highschoolscore: $highschoolscore
    ) {
      success
      message
    }
  }
`;

//Delete Neighbor
const Deleteneighborhood = gql`
  mutation DeleteNeighbor($id: String) {
    deleteNeighborhood(id: $id) {
      success
      message
    }
  }
`;

//Get All Neighbor
const QUERY_getAllNeighborList = gql`
  query getAllNeighbourList(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getAllNeighbourList(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      name
      city
      state
      streetaddress
      zip
      npiCityRanking
      npiAreaRanking
      reviewSummary
      reviewOneLiner
      schoolScore
      crimeRate
      walkability
      publicspaces
      curbAppeal
      price
      npi
      valueIndex
      keyword
      similarneighborhoodIds
      similarneighborhoodIds_list {
        id
        name
        city
        state
        npiCityRanking
        npiAreaRanking
        reviewSummary
        reviewOneLiner
        schoolScore
        crimeRate
        walkability
        publicspaces
        curbAppeal
        price
        npi
        valueIndex
        keyword
      }
    }
  }
`;

const QUERY_getAllSimilarNeighbourList = gql`
  query getAllSimilarNeighbourList(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getAllSimilarNeighbourList(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      name
      city
      state
      npiCityRanking
      npiAreaRanking
      reviewSummary
      reviewOneLiner
      schoolScore
      crimeRate
      walkability
      publicspaces
      curbAppeal
      price
      npi
      valueIndex
      keyword
      label
      value
      school
      crime
      neighborhoodImages {
        imageurl
        thumbnailurl
      }
      is_display_dev
      is_display_prod
      nhfullname
    }
  }
`;

const QUERY_getsubscription = gql`
  query getsubscription(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getsubscription(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      email
      subscribe_for
      date
      neighborhoodid
      neighborhoodfullname
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addNeighborhood(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddNeighborhood,

        variables: {
          name: adddata.name,
          city: adddata.city,
          state: adddata.state,
          streetaddress: adddata.streetaddress,
          zip: adddata.zip,
          npiCityRanking: adddata.npiCityRanking,
          npiAreaRanking: adddata.npiAreaRanking,
          reviewSummary: adddata.reviewSummary,
          reviewOneLiner: adddata.reviewOneLiner,
          schoolScore: adddata.schoolScore,
          crimeRate: adddata.crimeRate,
          walkability: adddata.walkability,
          publicspaces: adddata.publicspaces,
          curbAppeal: adddata.curbAppeal,
          price: adddata.price,
          npi: adddata.npi,
          valueIndex: adddata.valueIndex,
          keyword: adddata.keyword,
          similarneighborhoodIds: adddata.similarneighborhoodIds,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function createsubscription(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddSubscription,
        variables: {
          email: adddata.email,
          subscribe_for: adddata.subscribe_for,
          date: adddata.date,
          neighborhoodid: adddata.neighborhoodid,
          neighborhoodfullname: adddata.neighborhoodfullname,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateNeighborhood(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Updateneighborhood,

        variables: {
          id: updatedata.id,
          walkscorestatus: updatedata.walkscorestatus,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateneighborhoodcrime(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Updateneighborhoodcrime,

        variables: {
          name: updatedata.name,
          county_name: updatedata.county_name,
          postalcity_name: updatedata.postalcity_name,
          crime: updatedata.crime,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updatemarketingfactor(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Updatemarketingfactor,
        variables: {
          id: updatedata.id,
          medianprice: updatedata.medianprice,
          appreciation: updatedata.appreciation,
          dom: updatedata.dom,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateneighborhoodmedianprice(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Updateneighborhoodmedianprice,

        variables: {
          name: updatedata.name,
          county_name: updatedata.county_name,
          postalcity_name: updatedata.postalcity_name,
          medianprice: updatedata.medianprice,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateneighborhoodschool(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Updateneighborhoodschool,

        variables: {
          name: updatedata.name,
          county_name: updatedata.county_name,
          postalcity_name: updatedata.postalcity_name,
          school: updatedata.school,
          primaryschoolscore: updatedata.primaryschoolscore,
          middleschoolscore: updatedata.middleschoolscore,
          highschoolscore: updatedata.highschoolscore,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Delete Function

async function deleteNeighborhood(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Deleteneighborhood,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllNeighborList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllNeighborList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getAllSimilarNeighbourList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllSimilarNeighbourList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getsubscription(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getsubscription,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addNeighborhood,
  updateNeighborhood,
  deleteNeighborhood,
  getAllNeighborList,
  getAllSimilarNeighbourList,
  updateneighborhoodcrime,
  updateneighborhoodschool,
  updateneighborhoodmedianprice,
  updatemarketingfactor,
  createsubscription,
  getsubscription,
};
